module.exports = __webpack_public_path__ + "assets/b88c15e7a4b7537e0378e36662f61d80-DSC_0739.jpg";